import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../../auth";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const { currentUser } = useContext(AuthContext);
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={(props) =>
        currentUser && restricted ? (
          <Redirect to="/" />
        ) : (
          <Component
            {...props}
            key={
              props.match.params && props.match.params.id
                ? props.match.params.id
                : null
            }
          />
        )
      }
    />
  );
};

export default PublicRoute;
